// A union's profile lives on its own union_accounts row -- that is the single source of truth
// every union-side feature keys on (apprenticeships, exams, portfolio, messaging, the public
// /unions/:slug page). The separate `unions` table is the older curated public directory;
// unions.union_account_id links a directory entry to a real login for the one historical
// curated union, and nothing new is created there.
//
// The slug is what makes the public page reachable, so it is written at signup (it used to
// appear only after the first dashboard Save, leaving new unions with no public page at all).

export function unionSlug(name, localNumber) {
  const base = `${name || 'union'} ${localNumber || ''}`
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  return base || 'union';
}
